var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:`ui__chip ${_vm.isSmall ? 'ui__chip--small' : ''}`},[_c('div',{staticClass:"ui__chip__wrapper"},[(_vm.img)?_c('div',{staticClass:"ui__chip__img",style:(`background-image: url('${_vm.img}')`)}):_c('div',{staticClass:"ui__chip__spacer"}),_c('div',{staticClass:"ui__chip__text"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }